import { render } from "./act-access-overview.vue?vue&type=template&id=7870cb2c&ts=true"
import script from "./act-access-overview.ts?vue&type=script&lang=ts&external"
export * from "./act-access-overview.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__